import { Component } from "react";

class FactSheetTab extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <div className="row-wide">
                    <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>FMS ID</label>
                            <input name="FMSID" type="text" placeholder="FMS ID" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>
                    <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>Title</label>
                            <input name="TITLE" type="text" placeholder="TITLE" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>                 
                </div>
                <div className="row-wide">
                <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>PROJECT INTENT</label>
                            <input name="PROJECTiNTENT" type="text" placeholder="PROJECT INTENT" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>
                    <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>SCOPE OF WORK</label>
                            <input name="SCOPEOFWORK" type="text" placeholder="SCOPE OF WORK" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>  
                </div>
                <div className="row-wide">
                <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>IMAGE</label>
                            <input name="IMAGE" type="text" placeholder="IMAGE" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>
                    <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>CLIENT AGENCY</label>
                            <input name="CLIENTAGENCY" type="text" placeholder="CLIENT AGENCY" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>  
                </div>
        
                
       
                <div className="row-wide">
                <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>COMMISSIONER</label>
                            <input name="COMMISSIONER" type="text" placeholder="COMMISSIONER" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>
                    <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>FIRST DEPUTY COMMISSIONER</label>
                            <input name="FDCOMMISSIONER" type="text" placeholder="FIRST DEPUTY COMMISSIONER" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>  
                </div>

                <div className="row-wide">
                <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>ASSOCIATE COMMISSIONER</label>
                            <input name="ASSOCIATECOMMISSIONER" type="text" placeholder="ASSOCIATE COMMISSIONER" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>
                    <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>EXECUTIVE DIRECTOR</label>
                            <input name="EXECUTIVEDIRECTOR" type="text" placeholder="EXECUTIVE DIRECTOR" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>  
                </div>

                <div className="row-wide">
                <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>PM DIRECTOR</label>
                            <input name="PMDIRECTOR" type="text" placeholder="PM DIRECTOR" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>
                    <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>CONSTRUCTION DIRECTOR</label>
                            <input name="CONSTRUCTIONDIRECTOR" type="text" placeholder="CONSTRUCTION DIRECTOR" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>  
                </div>

                <div className="row-wide">
                <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>ENGINEER IN-CHARGE</label>
                            <input name="ENGINEERIN-CHARGE" type="text" placeholder="ENGINEER IN-CHARGE" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>
                    <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>RESIDENT ENGINEER</label>
                            <input name="RESIDENTENGINEER" type="text" placeholder="RESIDENT ENGINEER" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>  
                </div>


                <div className="row-wide">
                <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>MAIN PROJECT LOCATIONS</label>
                            <input name="MAINPROJECTLOCATIONS" type="text" placeholder="MAIN PROJECT LOCATIONS" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>
                    <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>PROJECT AREA</label>
                            <input name="PROJECTAREA" type="text" placeholder="PROJECT AREA" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>  
                </div>

                <div className="row-wide">
                <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>BUDGET CONSTRUCTION</label>
                            <input name="BUDGETCONSTRUCTION" type="text" placeholder="BUDGET CONSTRUCTION" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>
                    <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>CURRENT CONSTRUCTION COST</label>
                            <input name="CURRENTCONSTRUCTIONCOST" type="text" placeholder="CURRENT CONSTRUCTION COST" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>  
                </div>

                <div className="row-wide">
                <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>REI SERVICES</label>
                            <input name="REISERVICES" type="text" placeholder="REI SERVICES" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>
                    <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>DESING CONSULTANT</label>
                            <input name="DESINGCONSULTANT" type="text" placeholder="DESING CONSULTANT" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>  
                </div>


                <div className="row-wide">
                <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>CONTRACTORS</label>
                            <input name="CONTRACTORS" type="text" placeholder="CONTRACTORS" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>
                    <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>CONTRACT DURATION</label>
                            <input name="CONTRACTDURATION" type="text" placeholder="CONTRACT DURATION" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>  
                </div>


                <div className="row-wide">
                <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>NOTICE TO PROCEED</label>
                            <input name="NOTICETOPROCEED" type="text" placeholder="NOTICE TO PROCEED" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>
                    <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>ORIGINAL CONTRACT COMPLETION DATE</label>
                            <input name="ORIGINALCONTRACTCOMPLETIONDATE" type="text" placeholder="ORIGINAL CONTRACT COMPLETION DATE" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>  
                </div>


                <div className="row-wide">
                <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>EXPECTED COMPLETION DATE</label>
                            <input name="EXPECTEDCOMPLETIONDATE" type="text" placeholder="EXPECTED COMPLETION DATE" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>
                  
                </div>


                <div className="row-wide">
                <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>LAST UPDATED DATE</label>
                            <input name="LASTUPDATEDDATE" type="text" placeholder="LAST UPDATED DATE" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>
                    <div className="col l6 m6 s12">
                        <div className="padding-top-2 padding-bottom-2">
                            <label>LAST UPDATED BY</label>
                            <input name="LASTUPDATEDBY" type="text" placeholder="LAST UPDATED BY" defaultValue=''className="margin-left-275" />
                        </div>
                    </div>  
                </div>

            </div>
        )
    }

}

export default FactSheetTab;